import { constants } from "../constants/redux-constants";

export const recordingStatus = (shouldReset) => ({
  type: constants.RECORDING_STATUS,
  payload: shouldReset,
});
export const recordingStopped = (payload) => ({
  type: constants.RECORDING_STOPPED,
  payload: payload,
});

export const recordingPaused = (payload) => ({
  type: constants.RECORDING_PAUSED,
  payload: payload,
});

export const recordingDraft = (payload) => ({
  type: constants.RECODING_DRAFT,
  payload: payload,
});
